import ApiService from '@shared/services/api.service';

const sslPath = '/ssl_monitoring';
const dnsPath = '/dns_monitoring';
const whoisPath = '/whois_monitoring';

const DomainMonitorService = {
  fetchSslList: async () => ApiService.get(`${sslPath}`),
  addSsl: async (body) => ApiService.post(`${sslPath}`, body),
  deleteSslById: async (id) => ApiService.delete(`${sslPath}/${id}/`),
  fetchSslMonitoringRecordById: async (id) => ApiService.get(`${sslPath}/${id}/baseline_certificate`),
  fetchSslRecordCapturedByIdAndRecord: async (id, record) => ApiService.get(`${sslPath}/${id}/records/${record}/certificate`),
  fetchSslHistoryList: async (pagin, id) => ApiService.get(`${sslPath}/${id}/records?page=${pagin.current}&items_per_page=${pagin.pageSize}`),
  updateOneSsl: async (id, body) => ApiService.put(`${sslPath}/${id}`, body),

  fetchDnsList: async () => ApiService.get(`${dnsPath}`),
  addDns: async (body) => ApiService.post(`${dnsPath}`, body),
  deleteDnsById: async (id) => ApiService.delete(`${dnsPath}/${id}/`),
  fetchDnsMonitoringRecordById: async (id) => ApiService.get(`${dnsPath}/${id}/baseline_dns_records`),
  fetchDnsRecordCapturedByIdAndRecord: async (id, record) => ApiService.get(`${dnsPath}/${id}/records/${record}/dns_records`),
  fetchDnsHistoryList: async (pagin, id) => ApiService.get(`${dnsPath}/${id}/records?page=${pagin.current}&items_per_page=${pagin.pageSize}`),
  updateOneDns: async (id, body) => ApiService.put(`${dnsPath}/${id}`, body),
  // ---> DNSMonitoringList.handleRebaselineRecord > rebaselineDns > POST /dns_monitoring/{id}/rebaseline (reset baseline to current state)
  rebaselineDns: async (id) => ApiService.post(`${dnsPath}/${id}/rebaseline`),

  fetchWhoisList: async () => ApiService.get(`${whoisPath}`),
  addWhois: async (body) => ApiService.post(`${whoisPath}`, body),
  deleteWhoisById: async (id) => ApiService.delete(`${whoisPath}/${id}/`),
  fetchWhoisMonitoringRecordById: async (id) => ApiService.get(`${whoisPath}/${id}/baseline_whois_data`),
  fetchWhoisRecordCapturedByIdAndRecord: async (id, record) => ApiService.get(`${whoisPath}/${id}/records/${record}/whois_data`),
  fetchWhoisHistoryList: async (pagin, id) => ApiService.get(`${whoisPath}/${id}/records?page=${pagin.current}&items_per_page=${pagin.pageSize}`),
  updateOneWhois: async (id, body) => ApiService.put(`${whoisPath}/${id}`, body),

  fetchContactGroups: async () => ApiService.get('/contact_groups')
};
export default DomainMonitorService;
